import React from 'react';
import { CockpitButton } from 'components/views/atoms/CockpitButton';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { keyframes } from '@emotion/react';

export type ReloadButtonProps = {
    reloading: boolean;
    size?: SizeProp;
    disabled?: boolean;
    onClick?: () => void;
}

const reload = keyframes({
    from: {
        transform: 'rotate(0deg)'
    },
    to: {
        transform: 'rotate(360deg)'
    }
});

function iconFromState(reloading: boolean) {
    return reloading
        ? { icon: faRedoAlt, animation: `${reload} 1s linear infinite` }
        : { icon: faRedoAlt }
        ;
}

export const ReloadButton = (props: ReloadButtonProps) => {
    const { reloading, disabled, ...otherProps } = props;

    return (
        <CockpitButton {...iconFromState(reloading)} disabled={disabled} {...otherProps} />
    );
};
